// The payment banner (Main.dc.html, its "Payment overdue" and "Access suspended" Tweaks): on every
// shell page while a payment is overdue or access is suspended for it, with 1 button, Update card,
// which opens Stripe's card form for that product's billing (docs/data-model.md 3.2). The link
// still points at Account, where Billing is, for anyone the portal can't open for. A place someone
// else's subscription pays for (a partner seat, billing/payer.js; target.paidByOther) has no Update card:
// the card is the payer's, and the banner's words name their payment.
// While staff view as a member, Update card opens nothing and says why (lib/viewAs.jsx).
import { useState } from 'react'
import { Link } from '../lib/router.jsx'
import { SITE } from '../config/site.js'
import { openBillingPortal } from '../lib/billing.js'
import { useViewingAs, isViewingAsRefusal, VIEWING_AS_LINE } from '../lib/viewAs.jsx'
import { CardIcon } from './Marks.jsx'

export const PORTAL_FAILED = `Stripe's card page didn't open. Try again, or email ${SITE.helpEmail}.`

// Update card, as a link to Account that opens the portal instead when there's a customer to open
// it for. state: idle, opening, failed (PORTAL_FAILED) or viewing_as (VIEWING_AS_LINE); message is
// the line to show for the last 2.
export function useUpdateCard(target) {
  const viewingAs = useViewingAs()
  const [state, setState] = useState('idle')
  function onClick(e) {
    if (viewingAs) {
      e.preventDefault()
      setState('viewing_as')
      return
    }
    if (!target?.hasCustomer) return
    e.preventDefault()
    if (state === 'opening') return
    setState('opening')
    openBillingPortal({ productId: target.productId, flow: 'card' })
      .then(() => setState('idle'))
      .catch(err => setState(isViewingAsRefusal(err) ? 'viewing_as' : 'failed'))
  }
  const message = state === 'failed' ? PORTAL_FAILED : state === 'viewing_as' ? VIEWING_AS_LINE : null
  return { state, onClick, message }
}

export function PaymentBanner({ text, target, phone }) {
  const card = useUpdateCard(target)
  if (!text) return null
  return (
    <div className={phone ? 'lib-banner lib-banner--phone' : 'lib-banner'}>
      <div className="lib-banner-text" role={card.message ? 'alert' : undefined}>
        <CardIcon /><span>{card.message || text}</span>
      </div>
      {!target?.paidByOther && (
        <Link to="/account" className="lib-banner-btn" onClick={card.onClick} aria-busy={card.state === 'opening' || undefined}>Update card</Link>
      )}
    </div>
  )
}
